module.exports = __webpack_public_path__ + "img/default-background.83dbeb72.webp";